import { ArrowUpRight, Mic, Paperclip, Plus } from 'lucide-react';
import { Link } from 'react-router-dom';

const backgroundImage =
  'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/gen_ai_bg_5.avif';

export default function GenerativeAIHero() {
  return (
    <section
      id="top"
      className="relative isolate flex min-h-[calc(100svh-76px)] flex-col items-center overflow-hidden bg-[#080b1d] px-5 pb-8 pt-12 text-white sm:px-6 sm:pt-16 lg:min-h-[calc(100svh-76px)] lg:pt-20"
      style={{
        backgroundImage: `linear-gradient(180deg, rgba(8, 15, 51, 0.48), rgba(5, 8, 24, 0.83)), url('${backgroundImage}')`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
      }}
      aria-labelledby="generative-ai-hero-title"
    >
      <div
        className="pointer-events-none absolute inset-0 -z-10"
        style={{
          background:
            'radial-gradient(ellipse at 50% 28%, rgba(35, 91, 220, 0.27), transparent 54%)',
        }}
        aria-hidden="true"
      />

      <div className="mx-auto w-full max-w-7xl text-center">
        <h1
          id="generative-ai-hero-title"
          className="mx-auto max-w-4xl text-white text-4xl font-medium leading-[1.08] tracking-[-0.035em] sm:text-5xl lg:text-6xl"
        >
          Generative AI That Moves Your Business Forward
        </h1>
        <p className="mx-auto mt-5 max-w-7xl text-center text-white sm:mt-6 text-base font-normal leading-[27px]">
          We design, build and govern enterprise AI—from strategy and generative applications to
          autonomous agents—so your ideas can scale with confidence.
        </p>
        <Link
          to="/contact"
          onClick={() => window.scrollTo(0, 0)}
          className="mt-7 inline-flex min-h-12 items-center justify-center gap-2 rounded-lg border border-white/20 bg-[#315BFF] px-6 py-3 text-sm font-semibold text-white shadow-[0_8px_24px_rgba(24,72,255,0.35)] transition-colors hover:bg-[#2448e8] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-white sm:mt-8 sm:text-base"
        >
          Start a conversation
          <ArrowUpRight size={17} aria-hidden="true" />
        </Link>
      </div>

      <div className="mx-auto mt-10 w-full max-w-2xl rounded-2xl border border-white/10 bg-[#12346d]/90 p-2.5 shadow-[0_24px_70px_rgba(0,0,0,0.45)] backdrop-blur-sm sm:mt-12 sm:p-3">
        <div className="px-3 pb-3 pt-1 text-left text-xs font-medium text-blue-100 sm:px-4">
          Generative AI / Assistant
        </div>
        <div className="flex min-h-36 flex-col justify-between rounded-xl border border-white/10 bg-[#11131d] p-4 text-left sm:min-h-40 sm:p-5">
          <p className="text-white/75 text-base font-normal leading-[27px]">
            Hi! How can I help you put AI to work today?
          </p>
          <div className="mt-8 flex items-center justify-between text-white/55">
            <div className="flex items-center gap-4">
              <Plus size={19} aria-hidden="true" />
              <Paperclip size={18} aria-hidden="true" />
            </div>
            <div className="grid h-9 w-9 place-items-center rounded-lg border border-white/10 bg-white/5" aria-hidden="true">
              <Mic size={17} aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
